/*******************************************************************************
Add the Hover Class To An Element
Adds the hover class to an element. Prevents touch events from triggering the hover state.
*******************************************************************************/

let touchDetected = false;

export default function addHoverClass(e) {

    // 'touchstart' comes through before 'mousenter', but both will fire on IOS
    // If 'touchstart' is fired, we can set the global touchDetected variable to true
    // That way we know when to avoid trigging the hover state (which is sticky on IOS)
    if (e.type === 'touchstart') { touchDetected = true; }

    // As long as a touch was not detected, add the 'hovering' class which creates the hover state
    if (!touchDetected) { $(this).addClass('hovering'); }

    // Reset the global touchDetected variable to false so it's ready for the next time
    if (e.type === 'mouseenter') { touchDetected = false; }
}
